export const redirectLink = (link = '') => {
  window.open(link, '_blank', 'noopener')
}
